import React from "react";
import code from "../../images/code.png";
const ScanCode = ({ font }) => {
  return (
    <div className="flex justify-center items-center  flex-col gap-5 text-center">
      <p className={` lg:text-2xl md:text-2xl text-xl ${font}`}>
        or scan QR code
      </p>
      <img src={code} alt="" className="w-2/5" />
    </div>
  );
};

export default ScanCode;
